<onboarding-container
  [formValid]="true"
  [displayProgressBar]="false"
  [buttonLabel]="'onboarding.savings-plan.favorite-suggestion.button' | transloco"
  [specialAction]="'onboarding.savings-plan.favorite-suggestion.specialAction' | transloco"
  (back)="goBack()"
  (specialActionClicked)="wantAnotherSavingsPlan()"
  (forward)="goNext()"
>
  <p class="zero-text p-huge-med">{{ 'onboarding.savings-plan.favorite-suggestion.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.savings-plan.favorite-suggestion.text' | transloco }}</p>
</onboarding-container>
